/**
 * 创建百度地图
 */
  /* eslint-disable */
export function createMap() {
  // 初始化百度地图脚本...
  const AK = "Ai5bbFghmPibkvalVXAGrnwXkci5M9Wx";
  const BMap_URL = "https://api.map.baidu.com/api?type=webgl&v=1.0&ak=" + AK + "&s=1&callback=onBMapCallback";
  return new Promise(resolve => {
    // 如果已加载直接返回
    if (typeof BMapGL !== "undefined") {
      // eslint-disable-next-line no-undef
      resolve(BMapGL);
      return true;
    }

    // 百度地图异步加载回调处理
    window.onBMapCallback = function() {
      // 百度地图脚本初始化成功
      // eslint-disable-next-line no-undef
      resolve(BMapGL);
    };

    // 插入script脚本
    let scriptNode = document.createElement("script");
    scriptNode.setAttribute("type", "text/javascript");
    scriptNode.setAttribute("src", BMap_URL);
    document.body.appendChild(scriptNode);
  });
}

/**
 * 初始化地图
 */
  /* eslint-disable */
export function initMap(BMapGL, options) {
  options = Object.assign(
    {
      tilt: 50,
      heading: 0,
      center: [113.019353, 28.200509],
      zoom: 14,
    },
    options
  );
  const map = new BMapGL.Map(options.el || "map_container", {
    restrictCenter: false,
    // style: { styleJson: options.style || styleJson },
  });
  // map.enableKeyboard(); // 键盘操作
  map.enableScrollWheelZoom(); // 缩放
  map.enableInertialDragging(); // 惯性拖拽
  map.enableContinuousZoom(); // 双击平滑缩放
  map.disableDoubleClickZoom(); // 关闭双击缩放

  map.setDisplayOptions(
    options.displayOptions || {
      // 隐藏室内图等地图样式
      poi: false,
      indoor: false,
      skyColors: ["rgba(5, 5, 30, 0.01)", "rgba(5, 5, 30, 0.1)"],
    }
  );
  if (options.center && options.zoom) {
    map.centerAndZoom(new BMapGL.Point(options.center[0], options.center[1]), options.zoom);
  }

  map.setTilt(options.tilt);
  map.setHeading(options.heading);
  return map;
}
